import React from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import SonderLogo from "../../../assets/images/sonder_logo_outline.svg";

import styles from "./ImagePlaceholder.module.scss";

function ImagePlaceholder({ className }) {
  return (
    <div className={classnames(styles.container, className)}>
      <img
        className={styles.image_placeholder}
        src={SonderLogo}
        alt="Sonder Logo Outline"
      />
    </div>
  );
}

ImagePlaceholder.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
};

ImagePlaceholder.defaultProps = {
  className: null,
};

ImagePlaceholder.displayName = "ImagePlaceholder";

export default ImagePlaceholder;
